export default {
    url: '/users',
    template: '<reports-users classifiers="vm.classifiers" sites="vm.sites" default-filter="vm.defaultFilter" />',
    resolve: {
        sites: (SiteResource) => SiteResource.query({ reportUserResultsSites: true, pageSize: 0 }).$promise
    },
    controller (classifiers, sites) {
        this.classifiers = classifiers;
        this.sites = sites;
        this.defaultFilter = { };
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/reports/users/index.js